import { isNumber } from "lodash";

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function validUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/* 合法uri */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/* 小写字母 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function isEmail(email) {
  const re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,6}$/g;
  return re.test(email);
}

export function isMobile(value) {
  return /^[1][0-9]{10}$/.test(value);
}

export default class Validator {
  constructor(VueComponent, form) {
    this.callback = []; // 回调函数
    this.rules = VueComponent.rules; // 表单规则
    this.formName = VueComponent.$refs[form]; // 表单
    this.data = VueComponent.form;

    const errorMsgs = {
      min: "输入数据长度不足",
      number: "请输入数字",
      mobile: "请输入正确的手机号",
      email: "请输入正确的邮箱",
      required: "内容不为空"
    };
    this.rulesByName = {
      required(value, errorMsg) {
        if (value === "") {
          return errorMsg || errorMsgs.required;
        }
      },
      mobile(value, errorMsg) {
        if (!isMobile(value)) {
          return errorMsg || errorMsgs.mobile;
        }
      },
      email(value, errorMsg) {
        if (!isEmail(value)) {
          return errorMsg || errorMsgs.email;
        }
      },
      number(value, errorMsg) {
        if (!isNumber(value)) {
          return errorMsg || errorMsgs.number;
        }
      },
      length(value, [min, max], errorMsg) {
        if (value.length < min || value.length > max) {
          return errorMsg || errorMsgs.min;
        }
      }
    };
  }

  // 添加校验规则
  add(value, rule, data) {
    const arg = [value];
    const { rulesByName } = this;

    if (rule.min >= 0 || rule.max >= 0) {
      rule.type = "length";
      const arr = [0];
      if (rule.min >= 0) {
        arr[0] = rule.min;
      }
      if (rule.max >= 0) {
        arr.push(rule.max);
      }
      arg.push(arr);
    }

    arg.push(rule.message);
    arg.push(data);

    this.callback.push(() => {
      // 进行校验
      const type = rule.required ? "required" : rule.type;
      const method = rulesByName[type] || rule.validator || function() {};
      return typeof method === "function" && method.apply(this, arg);
    });
  }

  /**
   * 开始校验
   * @param {String} current 当前项，空值表示全部项
   * @return {Object} { valid, error }
   */
  validate(current = "") {
    const error = {};
    let valid = true;
    if (this.formName === undefined) {
      return {};
    }
    const items = this.formName.querySelectorAll("[prop]");

    Object.keys(items).map(key => {
      const item = items[key];
      // 每项的值和规则
      const name = item.getAttribute("prop");
      if (current && current !== name) return;
      const { value } = item.getElementsByTagName("input")[0];
      const rules = this.rules[name] || [];

      // 缓存规则
      rules.forEach(rule => {
        this.add(value, rule, this.data);
      });
      error[name] = {
        isError: ""
      };

      // 执行规则
      for (let i = 0; i < this.callback.length; ++i) {
        const message = this.callback[i]();
        if (message) {
          error[name] = {
            isError: true,
            message
          };
          if (valid) {
            valid = false;
          }
          break;
        } else {
          error[name] = {
            isError: false
          };
        }
      }

      // 清除当前项规则函数
      this.callback = [];
      return items[key];
    });

    if (current === "") {
      Object.keys(error).forEach((name, index) => {
        const item = items[index].getElementsByTagName("input")[0];
        if (index === 0) {
          item.focus();
        }
      });
    }
    return { valid, error };
  }
}
